import services from 'services/services';
import * as types from '../types';

// Import helpers
import { checkFetchErrors } from '../helpers_actions/convert_helpers';

// ******************** FETCH PACKET TO EDIT ********************
export const fetchPacket = (id) => async (dispatch) => {
	try {
		// Dispatch a loading action
		dispatch({
			type: types.FETCH_PACKET_LOADING,
			payload: true
		});

		const response = await services.get(`/packet/${id}`);

		// Dispatch an action with data
		dispatch({
			type: types.FETCH_PACKET_SUCCESS,
			payload: response.data
		});
	} catch (error) {
		dispatch({
			type: types.FETCH_PACKET_ERROR,
			payload: checkFetchErrors(error)
		});
	}
};
